/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderCreateRequestSchema } from "./mobileOrderCreateRequestSchema.ts";
import { mobileOrderCreateSchema } from "./mobileOrderCreateSchema.ts";

export const orgUnitOrderCreateCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitOrderCreateCreateStatus200Schema = mobileOrderCreateSchema;

export const orgUnitOrderCreateCreateResponseSchema = orgUnitOrderCreateCreateStatus200Schema;

export const orgUnitOrderCreateCreateDataSchemaJson = mobileOrderCreateRequestSchema.optional();

export const orgUnitOrderCreateCreateDataSchemaXml = mobileOrderCreateRequestSchema.optional();

export const orgUnitOrderCreateCreateDataSchema = z.union([orgUnitOrderCreateCreateDataSchemaJson, orgUnitOrderCreateCreateDataSchemaXml]);
